import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import kaamwalaLogo from "../../../assets/KAAMVALALogo.png";
import Dropdown from "react-bootstrap/Dropdown";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { CiLogout } from "react-icons/ci";
import { FaUserAlt } from "react-icons/fa";
import { IoDocumentTextOutline, IoNotifications } from "react-icons/io5";
import { PiBagSimpleFill } from "react-icons/pi";
import { BsPeopleFill } from "react-icons/bs";
import { errorPopup, successPopup } from "../../../Utils/ToasterMessage";
import CompanyContext from "../ContextAPI/CompanyContext";
import { URLS } from "../../../Utils/App_urls";
import "./Navbar.css";
import defaultLogo from "../../../assets/dummy-image.jpg";
import { COMPANY_URLS } from "../../../Utils/Company_App_Urls";
import {
  getAllNotification,
  markAllAsRead,
  markAsReadNotification,
  markReadAndRefreshNotifications,
} from "../ContextAPI/ApiContext";
import { Oval } from "react-loader-spinner";
// import getAllNotication from '../ContextAPI/ApiContext';
// import { Badge } from 'react-bootstrap';

const notifications = [
  {
    title: "New Job Application Steps",
    message: "Stay updated on your applications! Visit the 'Applied Jobs'",
    date: "04 April, 2021",
    time: "04:00 PM",
  },
  {
    title: "Profile Update Reminder",
    message:
      "Your profile is incomplete. Complete it to get better job recommendations.",
    date: "05 April, 2021",
    time: "10:30 AM",
  },
  {
    title: "New Job Posting in Your Field",
    message: "Check out the latest job posting in your preferred category.",
    date: "06 April, 2021",
    time: "02:15 PM",
  },
  {
    title: "Interview Invitation",
    message:
      "You have been invited for an interview. Check your email for details.",
    date: "07 April, 2021",
    time: "09:00 AM",
  },
  {
    title: "Application Status Update",
    message:
      "Your application status has been updated. Visit 'Applied Jobs' for details.",
    date: "08 April, 2021",
    time: "03:45 PM",
  },
];

export default function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    setLoader,
    isCompanyProfileComplate,
    needTorender,
    profileLogo,
    setProfileLogo,
  } = useContext(CompanyContext);
  const [companyLogo, setCompanyLogo] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [expandedNav, setExpandedNav] = useState(false);
  const [showBadge, setShowBadge] = useState(false);
  const [allNotication, setAllNotification] = useState([]);
  const [notificationLoader, setNotificationLoader] = useState(false);

  const handleToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const handleBadgeToggle = () => {
    setShowBadge((prev) => !prev);
  };
  const handleNotification = () => {
    navigate("notification");
    setShowBadge((prev) => !prev);
  };

  const getCompanyDetails = () => {
    axios
      .get(`${COMPANY_URLS.get_profile}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        setProfileLogo(res?.data?.data?.companylogo);
      })
      .catch((err) => {});
  };

  const deleteFcmToken = () => {
    const fcmToken = { fcmDeviceToken: localStorage.getItem("fcmToken") };
    axios
      .delete(`${COMPANY_URLS.saveFcmToken}`, fcmToken, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {})
      .catch((err) => {});
  };

  const handleLogOut = () => {
    setLoader(true);
    axios
      .post(`${COMPANY_URLS.logout}`, {
        refreshToken: `${localStorage.getItem("acessToken")}`,
      })
      .then((res) => {
        successPopup(res?.data?.message);
        localStorage.removeItem("token");
        localStorage.removeItem("companyRole");
        localStorage.removeItem("isprofileComplete");
        localStorage.removeItem("registeredEmail");
        localStorage.removeItem("fcmToken");
        setLoader(false);
        navigate("/company/login");
        deleteFcmToken();
      })
      .catch((err) => {
        errorPopup(err?.response?.data?.message);
        setLoader(false);
      });
  };

  const checkLocation = () => {
    const locationArr = location.pathname.split("/");
    return locationArr || "";
  };

  const handleHomeLogoClick = () => {
    window.location.reload();
    navigate("/company/job-post");
  };

  useEffect(() => {
    getCompanyDetails();
  }, [needTorender]);

  useEffect(() => {
    checkLocation();
  }, []);

  useEffect(() => {
    const fetchNotifications = async () => {
      const notifications = await getAllNotification(5, 1);
      if (notifications) {
        setAllNotification(notifications);
      }
    };
    const intervalId = setInterval(fetchNotifications, 10000);
    return () => clearInterval(intervalId);
  }, []);

  const handleMarkAsRead = async (notificationId) => {
    try {
      const updatedNotifications = await markReadAndRefreshNotifications(
        notificationId,
        5,
        1
      );
      setAllNotification(updatedNotifications);
    } catch (error) {
      console.error("Error updating notifications:", error);
    }
  };

  const handleFormateDate = (dateStr = "") => {
    let date = new Date(dateStr);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    const timeFormated = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${formattedDate} | ${timeFormated}`;
  };

  return (
    <>
      <Helmet>
        <title>
          Kaamvala - Your Trusted Partner for Reliable Blue-Collar Jobs
        </title>
        <meta
          name="description"
          content="Kaamvala connects you with trustworthy office boys, plumbers, security guards, and more. Find reliable blue-collar help for all your needs today!"
        />
        <meta
          name="keywords"
          content="blue-collar jobs, office boy, plumber, security guard, reliable workers, Kaamvala, skilled labor, trustworthy workers, hiring help, blue-collar services"
        />
        <meta name="author" content="kaamvala" />
        <meta name="robots" content="index, follow" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.kaamvala.com/" />
        <meta
          property="og:title"
          content="Kaamvala - Your Trusted Partner for Reliable Blue-Collar Jobs"
        />
        <meta
          property="og:description"
          content="Kaamvala connects you with trustworthy office boys, plumbers, security guards, and more. Find reliable blue-collar help for all your needs today!"
        />
        <meta
          property="og:image"
          content="https://www.kaamvala.com/static/media/logo.svg"
        />
        <meta property="og:image:width" content="928" />
        <meta property="og:image:height" content="585" />
        <meta property="og:image:alt" content="Kaamvala Logo" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Kaamvala - Your Trusted Partner for Reliable Blue-Collar Jobs"
        />
        <meta
          name="twitter:description"
          content="Kaamvala connects you with trustworthy and skilled blue-collar workers, including office boys, plumbers, security guards, and more. Find reliable help for your needs today!"
        />
        <meta
          name="twitter:image"
          content="https://www.kaamvala.com/static/media/logo.svg"
        />

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0"
        />
        <meta name="theme-color" content="#07070f" />
        <meta name="msapplication-navbutton-color" content="#07070f" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="#07070f" />

        <script type="application/ld+json">
          {`
                {
                  "@context": "https://schema.org",
                  "@type": "Corporation",
                  "name": "kaamvala",
                  "alternateName": "Kaamvala",
                  "url": "https://www.kaamvala.com/",
                  "logo": "https://kaamvala.com/wp-content/themes/specto-fresh/image/LogoKaamvala.svg",
                  "sameAs": [
                    "https://www.facebook.com/people/Kaamvala/61555515489018/",
                    "https://www.linkedin.com/company/kaamvala/",
                    "https://www.instagram.com/kaamvala2024/"
                  ],
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "7th Floor, TOWER-C, Noida One, Unit C-720, Plot No. 8, Block B",
                    "addressLocality": "Noida",
                    "addressRegion": "Uttar Pradesh",
                    "postalCode": "201309",
                    "addressCountry": "IN"
                  },
                  "email": "mailto:info@kaamvala.com"
                }
              `}
        </script>
      </Helmet>
      <div className="main-navbar">
        <Navbar
          collapseOnSelect
          expanded={expandedNav}
          expand="lg"
          className="bg-body-tertiary m-0 w-100"
        >
          <Container fluid>
            <Navbar.Brand
              className={`${!isCompanyProfileComplate && "disabled-navItems"}`}
            >
              <img
                onClick={() => handleHomeLogoClick()}
                src={kaamwalaLogo}
                alt="kaamwalaLogo"
              />
            </Navbar.Brand>
            <div className="top-nav-bar">
              <div className="h-100 d-flex align-items-center gap-2">
                {/* <div className={`${!isCompanyProfileComplate && 'disabled-navItems'} login-btn user-avatar`}>
                                    <IoNotifications fontSize={24} />
                                    <Badge pill bg="primary">2</Badge>
                                </div> */}
                <Dropdown show={showBadge} onToggle={handleBadgeToggle}>
                  <div
                    onClick={handleBadgeToggle}
                    id="dropdown-basic"
                    className={`${
                      !isCompanyProfileComplate && "disabled-navItems"
                    } login-btn user-avatar`}
                  >
                    <IoNotifications fontSize={24} />
                    {allNotication?.unreadNotificaitonCount > 0 && (
                      <span className="badge-icon">
                        {allNotication?.unreadNotificaitonCount}
                      </span>
                    )}
                  </div>
                  <Dropdown.Menu className="notificaton_menu px-3 py-3">
                    <div>
                      <h4 className="notification-title d-flex justify-content-between">
                        <span>Notification</span>
                        <span
                          onClick={() => markAllAsRead(setNotificationLoader)}
                          className="markAsRead d-flex gap-1"
                        >
                          {notificationLoader && (
                            <Oval width={15} height={15} />
                          )}{" "}
                          Read All
                        </span>
                      </h4>
                      <div className={`notification-list-wrapper`}>
                        {allNotication?.notifications?.results?.length > 0 ? (
                          allNotication?.notifications?.results?.map(
                            (notification, index) => (
                              <div
                                key={index}
                                className={`notification-items-list mb-2 ${
                                  notification?.status === "unread" &&
                                  "unread_bg"
                                } `}
                              >
                                <p className="d-flex justify-content-between">
                                  <span>{notification.notificationTitle}</span>
                                  {notification?.status === "unread" && (
                                    <button
                                      onClick={() =>
                                        handleMarkAsRead(notification?._id)
                                      }
                                      className="markAsRead"
                                    >
                                      Mark Read
                                    </button>
                                  )}
                                </p>
                                <p>{notification.notificationBody}</p>
                                <p>
                                  {handleFormateDate(notification?.createdAt)}
                                </p>
                              </div>
                            )
                          )
                        ) : (
                          <p className="text-center">No Data</p>
                        )}
                      </div>
                      <span
                        onClick={handleNotification}
                        className="notification-title text-underline"
                      >
                        View All
                      </span>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown
                  className={`profile-drop-menu`}
                  show={showDropdown}
                  onToggle={handleToggle}
                >
                  <div
                    className={`login-btn user-avatar`}
                    id="dropdown-basic"
                    onClick={handleToggle}
                  >
                    {profileLogo ? (
                      <img
                        className="profile-iconNav"
                        src={profileLogo || defaultLogo}
                        alt="profile Image"
                      />
                    ) : (
                      <FaUserAlt fontSize={24} />
                    )}
                  </div>
                  <Dropdown.Menu className="profile-menu-items">
                    <Dropdown.Item
                      className={`${
                        !isCompanyProfileComplate && "disabled-navItems"
                      }`}
                      onClick={() => navigate("profile")}
                    >
                      <FaUserAlt fontSize={16} />
                      Profile
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogOut}>
                      <CiLogout fontSize={18} /> Log Out
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </Container>
        </Navbar>
      </div>
    </>
  );
}
